<template>
    <footer>
      <img class="email" src="./../assets/footer/youjian.png" alt="">
      <div class="text">购买及了解价格请咨询</div>
      <a href="mailto:business@muhuakeji.com" class="email-detail">business@muhuakeji.com</a>
      <hr class="line" >
      <div class="copyright"> ©{{currentYear}}上海沐桦科技有限公司 &nbsp; All rights reserved. </div>
      <div class="copyright"><a target="_blank" style="color: #fff;" href="https://beian.miit.gov.cn/">沪ICP备18045280号-1</a></div>
    </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    // msg: String,
  },
  data () {
    return {
      currentYear: (new Date()).getFullYear()
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

footer{
    background:linear-gradient(90deg,rgba(13,27,44,0.4) 0%,rgba(13,27,44,1) 100%);
    background-image: url('../assets/footer/bg.png');
    background-size: cover;
    text-align: center;
    color:rgba(255,255,255,1);
    padding-bottom: 24px;
    .email {
      width: 28px;
      height: 20px;
      margin: 34px 0 16px;
    }
    .text {
      font-weight:400;
      line-height:12px;
      font-size:9px;
      margin-bottom: 22px;
    }
    .email-detail {
      width:141px;
      height:31px;
      border-radius:2px;
      border:1px solid rgba(255,255,255,1);
      font-size:10px;
      font-weight:400;
      line-height:26px;
      padding: 4px 7px;
      margin: 10px;
      color:rgba(255,255,255,1);
    }
    .line{
      border: 0.5px solid rgb(255, 255, 255);
      width: 45px;
      margin: 17px auto;
    }
    .copyright{
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      margin: 12px;
    }
  }
</style>
